module.exports = __webpack_public_path__ + "static/media/nl.390aa40f.svg";